<template>
  <div>
    <keep-alive><router-view/></keep-alive>
  </div>
</template>

<script th:inline="javascript">
export default {
  name: 'App',
  components: {
  },
  data: function() {
    return {
      orgH: 0,
      editing: false
    }
  },
  created: function() {
    this.orgH = this.$getWH().height/*
    this.prt('created', window.location.href)
    const url = window.location.href
    if (url.indexOf('/mm') > -1) {
      this.goPage(url)
    }*/
  },
  /*
  mounted: function() {
    console.log('App.mounted', this.$route)
    window.addEventListener('resize', this.judgeKeyboardState)
    window.onpopstate = () => {
      if (!this.allowBack) { //    这个allowBack 是存在vuex里面的变量
        history.go(1)
      }
    }
  }, */
  beforeDestroy() {
    // window.removeEventListener('resize', this.judgeKeyboardState)
  },
  methods: {
    judgeKeyboardState() { // 判断是键盘弹起还是收回
      const newHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      var u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      if (isAndroid) {
        if (newHeight === this.orgH) {
          this.editing = false
          // $('#divBtm').css('height', this.$getWH().btmH + 'px')
          // $('#divMain').css('height', this.$getWH().mainH + 'px')
          window.scroll(0, 0)
        } else {
          this.editing = true
          // window.ccApp.click('键盘弹出.1')
        }
      }
    },
    prt(a, b) {
      console.log(`APP.${a}`, b)
    },
    goPage(url) {
      if (localStorage.getItem('token')) return
      const p1 = url.substring(url.indexOf('/mm'))
      const params = p1.split('/')// URL携带的参数
      this.$router.replace({
        path: '/login',
        query: {
          u1: params[2],
          fid: params[5]
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue